import { Box, Grid, Typography } from "@material-ui/core";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  getCargoAction,
  getCargoBarChart,
  getVehicleLevel4TableData,
} from "src/app-redux/hq-dashboard/actions/hqDashboardActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { IDashboard, IDashboardCargoBar } from "src/common/typings/hq-dashboard";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { useStyles } from "./style";
import { VehicleLevel4Table } from "./VehicleLevel4Table";
import {
  allBorderTerminals,
  selectedBorderTerminals,
  selectedEndDate,
  selectedStartDate,
} from "src/app-redux/hq-dashboard/hqDashboardSlice";
import moment from "moment";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

interface Props {}

export function Cargo({}: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const [showNoDataFound, setShowNoDataFound] = useState<boolean>(false);
  const [showNoBarDataFound, setShowNoBarDataFound] = useState<boolean>(true);
  const [showDetailsBox, setShowDetailsBox] = useState<boolean>(false);
  const [pieChartList, setpieChartList] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [totalAmountUnit, setTotalAmountUnit] = useState<string>("KG");
  const [barChartList, setbarChartList] = useState<any>([]);
  const [isOpenLevel4Dailog, setIsOpenLevel4Dailog] = useState(false);
  const selectedTerminals = useAppSelector(selectedBorderTerminals);
  const startDate = useAppSelector(selectedStartDate);
  const endDate = useAppSelector(selectedEndDate);

  const pieChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const [data, setData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });
  const [colors, setColors] = useState<any>([]);
  const [barChartData, setBarChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Vehicles",
        data: [],
        backgroundColor: "#FFD500",
        borderRadius: 50,
        barThickness: 10,
      },
    ],
  });
  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    onHover: (event: any, chartElement: any) => {
      event.native.target.style.cursor = chartElement.length ? "pointer" : "default";
    },
    onClick: async (event: any, chartElement: any) => {
      if (chartElement?.length > 0) {
        const index = chartElement[0]?.index;
        setdata2Cargo({
          type: barChartList[index].consignmentType,
          value: barChartList[index].weight,
        });
        const res: any = await dispatch(
          getVehicleLevel4TableData({
            startDate: startDate,
            endDate: endDate,
            isVehicleType: false,
            type: barChartList[index]?.consignmentType,
            terminalId: selectedTerminals.toString(),
            headerType: barChartHeading,
          })
        );
        setrows(res?.payload?.vehicleConsignmentCargoDetailList.length);
        toggleLevel4Dialog();
      }
    },
  };
  const [barChartHeading, setBarChartHeading] = useState<string>("");
  const [barChartHeadingValue, setBarChartHeadingValue] = useState<number>(0);
  const allBTs: any = useAppSelector(allBorderTerminals);
  const [data2Cargo, setdata2Cargo] = useState<any>({});
  const [rows, setrows] = useState<number>(0);
  const [selectedBTNames, setSelectedBTNames] = useState<any[]>([]);
  const [selectedCargo, setSelectedCargo] = useState<string>("");

  useEffect(() => {
    const arr: string[] = [];
    selectedTerminals.forEach((id: number) => {
      arr.push(allBTs.find((item: any) => item.id == id)?.alias);
      setSelectedBTNames(arr);
    });
  }, [selectedTerminals]);

  useEffect(() => {
    setShowDetailsBox(false);
    setShowNoBarDataFound(true);
    if (startDate && endDate && selectedTerminals.length > 0) {
      setShowNoDataFound(false);
      getInsight(startDate, endDate);
    } else {
      setShowNoDataFound(true);
    }
  }, [startDate, endDate, selectedTerminals]);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  const getInsight = async (startDate: string, endDate: string) => {
    const colors: any = [];
    const req: IDashboard = {
      startDate: startDate,
      endDate: endDate,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getCargoAction(req));

    if (res?.payload) {
      if (res.payload.cargoTypeInsightsWidget.length) {
        setShowNoDataFound(false);
        const amt = await res.payload.cargoTypeInsightsWidget.reduce(
          (partialSum: any, a: any) => partialSum + a.weight,
          0
        );
        setTotalAmount(amt >= 1000 ? kgToTon(amt) : amt);
        setTotalAmountUnit(amt >= 1000 ? "Ton" : "KG");
        setData({
          labels: res.payload.cargoTypeInsightsWidget.map((item: any) => {
            return item.cargoType;
          }),
          datasets: [
            {
              label: "",
              data: res.payload.cargoTypeInsightsWidget.map((item: any) => {
                return item.weight;
              }),
              backgroundColor: res.payload.cargoTypeInsightsWidget.map(() => {
                const colorCode = getNewColorCode();
                colors.push(colorCode);
                return colorCode;
              }),
              borderWidth: 0,
            },
          ],
        });
        setpieChartList(res.payload.cargoTypeInsightsWidget);
        setColors(colors);
        showCargo(res.payload.cargoTypeInsightsWidget[0]);
      } else {
        setShowNoDataFound(true);
        setTotalAmount(0);
        setTotalAmountUnit("KG");
        setData({
          labels: [],
          datasets: [
            {
              label: "",
              data: [],
              backgroundColor: [],
              borderWidth: 0,
            },
          ],
        });
        setpieChartList([]);
        setColors([]);
      }
    }
  };

  const kgToTon = (kg: number) => {
    const ton = kg / 1000;
    return ton;
  };

  const showCargo = async (cargoItem: any) => {
    setSelectedCargo(cargoItem.cargoType);
    const req: IDashboardCargoBar = {
      startDate: startDate,
      endDate: endDate,
      cargoType: cargoItem.cargoType,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getCargoBarChart(req));
    setShowDetailsBox(true);
    if (res?.payload) {
      if (res.payload.consignmentCargoInsightWidget.length) {
        setShowNoBarDataFound(false);
        setbarChartList(res.payload.consignmentCargoInsightWidget);
        setBarChartData({
          labels: res.payload.consignmentCargoInsightWidget.map((item: any) => {
            return item.consignmentType;
          }),

          datasets: [
            {
              label: "Weight (KG)",
              data: res.payload.consignmentCargoInsightWidget.map((item: any) => {
                return item.weight;
              }),
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading(cargoItem.cargoType);
        setBarChartHeadingValue(cargoItem.weight);
      } else {
        setShowNoBarDataFound(true);
        setBarChartData({
          labels: [],
          datasets: [
            {
              label: "Vehicles",
              data: [],
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading("");
        setBarChartHeadingValue(0);
      }
    }
  };

  const toggleLevel4Dialog = async () => {
    setIsOpenLevel4Dailog(!isOpenLevel4Dailog);
  };

  return (
    <>
      <TransitionDialog
        isOpen={isOpenLevel4Dailog}
        handleClose={toggleLevel4Dialog}
        maxWidth="xl"
        isCustomValidate={true}
      >
        <Grid container direction="row" className={classes.level4TableOrangeHead}>
          <Grid item xs={12} md={2}>
            <p className={classes.topDivHeadings}>Selected Period</p>
            <p>
              <b>From</b> : {moment(startDate).format("DD/MM/YYYY hh:mm A")}
            </p>
            <p>
              <b>To</b> : {moment(endDate).format("DD/MM/YYYY hh:mm A")}
            </p>
          </Grid>
          <Grid item xs={12} md={8} style={{ textAlign: "center" }}>
            <p className={classes.topDivHeadings}>Selected BT </p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {selectedBTNames.map((item, index) => {
                return (
                  <p key={index + item} style={{ marginBottom: 0, marginRight: "3px" }}>
                    {item} {index < selectedBTNames.length - 1 ? "," : ""}
                  </p>
                );
              })}
            </div>
          </Grid>
          <Grid item xs={12} md={2}>
            <p className={classes.topDivHeadings} style={{ textAlign: "center" }}>
              Cargo
            </p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ maxWidth: "50%" }}>{barChartHeading} =</p>
              <p>
                {barChartHeadingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} KG
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ maxWidth: "50%" }}>{data2Cargo.type} =</p>
              <p>
                {rows} {rows == 1 ? "Vehicle" : "Vehicles"} ({data2Cargo.value} KG)
              </p>
            </div>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            overflow: "auto",
            // display: showLevel4Table ? "block" : "none",
            maxHeight: "300px",
          }}
        >
          <VehicleLevel4Table />
        </Grid>
      </TransitionDialog>
      {/* Cargo Section */}
      <Grid
        item
        xs={12}
        className={classes.outer}
        style={{
          display: showNoDataFound ? "flex" : "none",
          justifyContent: "space-around",
          fontSize: "14px",
        }}
      >
        No records found.
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        style={{ display: showNoDataFound ? "none" : "flex" }}
      >
        {/* Total Cargo */}
        <Grid item xs={12} lg={showDetailsBox ? 7 : 12} className={classes.outer}>
          {/* Header */}
          <Grid item xs={12} md={7}>
            {/* Total Number */}
            <Grid item xs={12} md={7} container direction="row">
              <Typography className={classes.headingText}>Cargo: </Typography>
              <Typography className={classes.headingAmount}>
                {totalAmount.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              </Typography>
              <Typography className={classes.unit}>{totalAmountUnit}</Typography>
            </Grid>
          </Grid>
          <Grid container direction="row">
            {/* List */}
            <Grid
              item
              xs={12}
              md={5}
              lg={showDetailsBox ? 5 : 4}
              xl={showDetailsBox ? 4 : 3}
              className={classes.itemsList}
            >
              {pieChartList.map((item: any) => {
                return (
                  <Grid
                    container
                    direction="row"
                    key={item.cargoType}
                    className={
                      selectedCargo === item.cargoType
                        ? `${classes.selectedItem} ${classes.item}`
                        : classes.item
                    }
                    onClick={() => showCargo(item)}
                  >
                    <Grid container direction="row" item xs={7}>
                      <div
                        className="colorPicker"
                        style={{
                          width: "15px",
                          height: "15px",
                          margin: "0 10px 14px 0px",
                          backgroundColor: colors[pieChartList.indexOf(item)],
                        }}
                      ></div>
                      <Box className={classes.label}>{item.cargoType}</Box>
                    </Grid>
                    <Grid item xs={5} className={classes.labelNumber}>
                      {item.weight.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            {/* Pie Chart */}
            <Grid item xs={12} md={6} lg={6} xl={6} className={classes.pieChartDiv}>
              <Box maxWidth={350} maxHeight={350}>
                <Pie data={data} options={pieChartOptions} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* Bar Chart No Data */}
        <Grid
          item
          xs={12}
          lg={5}
          style={{
            display: showDetailsBox && showNoBarDataFound ? "block" : "none",
            justifyContent: "space-around",
            fontSize: "14px",
          }}
        >
          <Box
            className={classes.outer}
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "space-around",
              fontSize: "14px",
            }}
            sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
          >
            No data found.
          </Box>
        </Grid>
        {/* Bar Chart */}
        <Grid
          item
          xs={12}
          lg={5}
          style={{
            display: showDetailsBox && !showNoBarDataFound ? "block" : "none",
          }}
        >
          <Box
            className={classes.outer}
            style={{ height: "100%" }}
            sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
          >
            <Grid item container direction="row">
              <Grid item xs={9} container direction="row">
                <Typography className={classes.headingText}>{barChartHeading}: </Typography>
                <Typography className={classes.headingAmount}>
                  {barChartHeadingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
                </Typography>
                <Typography style={{ paddingTop: "8px", paddingLeft: "3px" }}>kg</Typography>
              </Grid>
              <Grid item xs={3}>
                {/* <Box
                  style={{
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#488cfb",
                    textDecoration: "underline",
                    paddingTop: "7px",
                  }}
                  onClick={toggleDialog}
                >
                  Comparison
                </Box> */}
              </Grid>
            </Grid>
            <Grid container direction="row">
              {barChartList.map((item: any) => {
                return (
                  <Grid
                    container
                    direction="row"
                    item
                    xs={6}
                    key={item.consignmentType}
                    className={classes.barChartItem}
                  >
                    <Grid item xs={7}>
                      {item.consignmentType ? item.consignmentType : "N/A"}:
                    </Grid>
                    <Grid item xs={5} className={classes.barChartItemAmount}>
                      {item.weight}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Bar options={barChartOptions} data={barChartData} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
